function matchThumbnailHeight() {
  const mediaList = document.querySelector('.product__media-list.contains-media.grid.grid--peek.list-unstyled.slider.slider--mobile');
  const thumbnailList = document.querySelector('.thumbnail-list.list-unstyled.slider.slider--mobile.slider--tablet-up');
  if (!mediaList || !thumbnailList) return;

  // Set the height of the thumbnail list to match the media list
  const mediaListHeight = mediaList.offsetHeight;
  if (mediaListHeight > 0) {
    thumbnailList.style.height = `${mediaListHeight}px`;
    thumbnailList.style.overflowY = 'auto';
  }
}

function resetThumbnailHeight() {
  const thumbnailList = document.querySelector('.thumbnail-list.list-unstyled.slider.slider--mobile.slider--tablet-up');
  if (thumbnailList) {
    thumbnailList.style.height = '';
    thumbnailList.style.overflowY = '';
  }
}

function handleResize() {
  // Always match height on resize
  matchThumbnailHeight();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    matchThumbnailHeight();
    window.addEventListener('resize', handleResize);
  });
} else {
  matchThumbnailHeight();
  window.addEventListener('resize', handleResize);
}